export interface ImageInterface {
    file?: File
    imageURL: string
}
export interface SizeRule {
    width: number
    height: number
}

export interface InputRule {
    maximumNumber?: number
    minimumNumber?: number
}

export const placeholderLogo: ImageInterface = {
    imageURL: '//via.placeholder.com/146/BBB9B9.webp?text=+',
}

export const placeholderBanner: ImageInterface = {
    imageURL: '//via.placeholder.com/310x146/BBB9B9.webp?text=+',
}

export const placeholderSplashscreen: ImageInterface = {
    imageURL: '//via.placeholder.com/146/BBB9B9.webp?text=+',
}

export function createImage(src?: string, placeholder?: ImageInterface): ImageInterface {
    if (src) {
        return { imageURL: src }
    }
    if (placeholder) {
        return placeholder
    }
    return { imageURL: '' }
}

// image parameter type as any to work on test context
// image parameter should always be of type HTMLImageElement
export function loadImage(imageFile: File, onload: (image: any, url: string) => void) {
    const imageElement = new Image()
    const imageUrl = URL.createObjectURL(imageFile)

    imageElement.onload = () => {
        onload(imageElement, imageUrl)
    }
    imageElement.src = imageUrl
}
